import { TbUserCheck } from 'react-icons/tb'

import { dictionaryCodeFormTemplate } from '../Components/DictionaryCodeHint'
import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { STATUS_LIST_COLUMNS, STATUS_LIST_FILTERS, statusListFields } from '../Contracts/StatusListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Статуси клієнтів» (сім'я `StatusList`, `SPEC-007` §4).
 *
 * Стан картки клієнта: системні коди `client-*` веде верифікація (`SPEC-009`).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListClientStatusResource: IResourceConfig = {
    title: 'Статуси клієнтів',
    fields: statusListFields(),
    table: {
        showColumns: STATUS_LIST_COLUMNS,
    },
    filter: {
        includeFields: STATUS_LIST_FILTERS,
    },
    // Підказка про код — у формі, над полем «Код» (`SPEC-007` §12)
    form: {
        template: dictionaryCodeFormTemplate,
    },
    places: {
        top: <TopMenu current="client-statuses" />,
    },
    restUrl: '/services/client_statuses',
    pageUrl: '/settings/client-statuses',
    pageConfig: {
        title: 'Статуси клієнтів',
        icon: <TbUserCheck />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
